(function () {
    var forgotPasswordCtrl = (function () {
        function forgotPassword() {
            this.init.apply(this, arguments);
        }

        forgotPassword.prototype = {
            init: function ($scope, $state, localStorageService, AuthService, $message, $Loading, MKioskService, $mdDialog, $translationService) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$state = $state;
                this.localStorageService = localStorageService;
                this.AuthService = AuthService;
                this.$message = $message;
                this.$Loading = $Loading;
                this.MKioskService = MKioskService;
                this.$mdDialog = $mdDialog;
                this.$translationService = $translationService;

                this.email = "";
            },
            submit: function () {
                this.$Loading.show();
                var _this = this;
                this.AuthService.sendResetPasswordEmail(this.email).then(function () {
                    var msg = _this.$translationService.getTranslation('ResetPasswordEmailSent');
                    var alert_1 = _this.$mdDialog.alert()
                    // .htmlContent("An email was sent to the email address linked to your account.<br><br>Please open that email and follow the instructions.")
                    .htmlContent(msg)
                    .ok(_this.$translationService.getTranslation('OK'))
                    .clickOutsideToClose(true);
                    _this.$mdDialog.show(alert_1);
                },  _this.$message.error)
                .finally(function () {
                    _this.$Loading.hide();
                });                
            },
            goBack: function () {
                this.$state.go("internal.login");
            },
        };
        forgotPassword.$inject = ['$scope', '$state', 'localStorageService', 'AuthService', '$message', '$Loading', 'MKioskService', '$mdDialog', '$translationService'];
        return forgotPassword;
    }());
    angular.module('internal.forgotpassword').controller('forgotPasswordCtrl', forgotPasswordCtrl)
})();